import { render, staticRenderFns } from "./elementInformation.vue?vue&type=template&id=4fdfca68"
import script from "./elementInformation.vue?vue&type=script&lang=ts"
export * from "./elementInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HtmlBrandButton: require('/codebuild/output/src3458403893/src/acredo-website/components/html/htmlBrandButton.vue').default})
